module.exports = __webpack_public_path__ + "static/media/p6.3a8995df.png";